import React from 'react';
import { Route, Redirect } from "react-router-dom";


function AuthenticateEmployer({ component: Component, ...rest }) {

    return (
        <Route {...rest} render={(props) => {
            if (localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) === true) {
                return <Component {...props} />
            } else {
                return <Redirect to="/" />
            }
        }} />
    )
};

export default AuthenticateEmployer;
